//!#system	

<template>
	<div class="dateEditorWrapper">
		<v-datetime-picker 
			:label="label"
			v-model="typeof model[fieldName] === 'string' ? new Date(model[fieldName]) : model[fieldName]"
			:textFieldProps="textFieldProps"
		/>
		<div class="displayValue"><span>{{ displayValue }}</span></div>
	</div>
</template>

<script>
import tools from '@/tools';
import moment from 'moment';

export default {
	name: 'FieldDate',
	props: {
		routeInfo: {
			type: Object
		},
		value: { // parent object that contains this field
			type: Object,
			default: () => {}
		},
		context: { // Create or update
			type: String,
			required: true
		},
		fieldName: {
			type: String,
			required: true
		},
		fieldInfo: {
			type: Object,
			default: () => {}
		},
		field: {
			type: Object,
			default: () => {}
		},
		'append-icon': { 
			type: String 
		},
		label: { 
			type: String 
		},
		hint: { 
			type: String 
		},
		rules: { 
			type: Array, 
			default: () => [] 
		},
		placeholder: { 
			type: String 
		}
	},
	data() {
		return {
			inputValue: null,
			model: this.value,
			nullDateTime: null,
			displayValue: null
		}
	},
	computed: {
		textFieldProps() {
			return {
				name: this.name + 'TextField',
				value: this.inputValue,
				label: this.label,
				'prepend-icon': 'event',
				readonly: true
			};
		},
		actualDate() {
			return this.model[this.fieldName];
		},
		dateValue() {
			if (!this.actualDate) return null;
			let dvalue = new Date(this.actualDate);
			return dvalue;
		}
	},
	methods: {
		updateModel() {
			this.$emit('input', this.model);
		},
		formatDate(date) {
			if (date === null) return '';
			if (date === '') return '';
			let m = moment(date);
			return m.format('YYYY-MM-DD HH:mm');
		},
		friendlyFormat(date) {
			if (date === null) return '';
			if (date === '') return '';
			let m = moment(date);
			return m.format('dddd, MMMM Do YYYY, h:mm:ss a (ZZ)');
		}
	},
	watch: {
		dateValue(val) {
			this.displayValue = this.friendlyFormat(this.dateValue);
		},
		actualDate(val) {
			if (this.actualDate !== this.lastEmitted) {
				this.updateModel(); 
				this.lastEmitted = this.actualDate;
			}
		},
		value() {
			this.model = { ...this.value };
		}
	},
	created() {
		if (['create', 'update'].includes(this.context)) {
			if (this.model[this.fieldName] && !(this.model[this.fieldName] instanceof Date)) {
				this.model[this.fieldName] = new Date(this.model[this.fieldName]);	
			}
		}
		if (['filter'].includes(this.context)) {
			if (!this.model[this.fieldName]) this.model[this.fieldName] = null; // default to nulls for the component to not freak out
		}
		if (this.model[this.fieldName]) {
			this.inputValue = this.formatDate(this.dateValue) || new Date;
			this.displayValue = this.friendlyFormat(this.dateValue);
		}
		this.updateModel();
	}
}
</script>

<style scoped>
	.dateEditorWrapper {
		margin-bottom: 20px;
	}
	.displayValue {
		margin: -18px 0 0 35px;
		font-size: 80%;
	}
</style>